import { render } from "./ContentBlocker.vue?vue&type=template&id=41194a62&scoped=true&lang=pug"
const script = {}

import "./ContentBlocker.vue?vue&type=style&index=0&id=41194a62&scoped=true&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41194a62"]])

export default __exports__